import { render, staticRenderFns } from "./Wine_Desktop.vue?vue&type=template&id=a62a3584&"
import script from "./Wine_Desktop.vue?vue&type=script&lang=js&"
export * from "./Wine_Desktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports